import { render, staticRenderFns } from "./SearchWithoutAdd.vue?vue&type=template&id=66efcb52"
import script from "./SearchWithoutAdd.vue?vue&type=script&lang=js"
export * from "./SearchWithoutAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports